<template>
  <div v-if="validated && status === 'success'">
    <b-card class="text-center border border-danger">
      <h3 class="fs-2 fw-bold">
        FVC internal draft
      </h3>
    </b-card>

    <product-breakdown
      :report-flavour="'draft'"
      :fvcdetailsid = this.$route.params.fvcdetailsid
      :supplied-password = this.$route.params.fvcpassword
      :internal-draft="true"
    />
  </div>
  <div v-else>
    <b-card>
      <h3 class="fs-2 fw-bold">
        {{ message }}
      </h3>
    </b-card>
  </div>
</template>

<script>

import ProductBreakdown from '@/views/products/ProductBreakdown.vue'
import { BCard } from 'bootstrap-vue'

export default {
  name: 'FVCDraft',
  components: {
    ProductBreakdown,
    BCard,
  },
  data() {
    return {
      validated: false,
      status: '',
    }
  },
  created() {
    this.checkUrlPassword()
  },
  methods: {
    checkUrlPassword() {
      const { fvcdetailsid, fvcpassword } = this.$route.params

      this.$http.get('reportflavours.cfc', {
        params: {
          method: 'validateUrlPassword',
          flavour: 'draft-fvc',
          fvcdetailsid,
          urlpassword: fvcpassword,
        },
      })
        .then(response => {
          const { data } = response
          if (data.STATUS === 'success') {
            this.validated = true
            this.status = data.STATUS
          } else {
            this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' })
        })
    },
  },
}
</script>
